import { render, staticRenderFns } from "./Check.vue?vue&type=template&id=51a67690&scoped=true&"
import script from "./Check.vue?vue&type=script&lang=js&"
export * from "./Check.vue?vue&type=script&lang=js&"
import style0 from "./Check.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Check.vue?vue&type=style&index=1&id=51a67690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a67690",
  null
  
)

export default component.exports